module.exports = __webpack_public_path__ + "static/img/credit-wuhu-2.90f59e7b.jpg";